import { render, staticRenderFns } from "./DoctorPatientPaymentBillCreate.vue?vue&type=template&id=5c2e3f61&scoped=true"
import script from "./DoctorPatientPaymentBillCreate.vue?vue&type=script&lang=js"
export * from "./DoctorPatientPaymentBillCreate.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientPaymentBillCreate.vue?vue&type=style&index=0&id=5c2e3f61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e3f61",
  null
  
)

export default component.exports